import { usePathname, useRouter } from 'next/navigation';

export default function useNavigateWithAnimation() {
    const router = useRouter();
    const pathname = usePathname();

    function navigateWithAnimation({
        e,
        link,
        state,
        replace = false,
        callback
    }: Partial<{
        e: any;
        link: any;
        state: any;
        replace: any;
        callback: any;
    }>) {
        e?.preventDefault();
        if ((link && link !== pathname) || callback) {
            document
                .querySelector('.index-temp .page-container:not(.fade-in)')
                ?.classList?.add('fade-out');
            setTimeout(() => {
                if (link) {
                    if (['http://', 'https://'].some((pattern) => link.includes(pattern))) {
                        if (typeof window !== 'undefined') window.location.href = link;
                    } else {
                        router.push(link, { replace, state });
                    }
                }
                callback?.();
            }, 100);
        }
    }

    function goBack() {
        navigateWithAnimation({ callback: () => router.back() });
    }

    return { navigateWithAnimation, goBack };
}
